module.exports = "#certificate-holder {\n    width: 100%;\n    height: 70vh;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/preview-certificate/preview-certificate.component.css
// module id = ./src/app/shared/components/preview-certificate/preview-certificate.component.css
// module chunks = main